import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import history from '../../../../core/history'
import AdviserProfiles from '../AdviserProfiles/AdviserProfiles'
import { actions } from './AdviserProfilesContainerActions'
import Spinner from '../../../../common/Spinners/Spinner'

class AdviserProfilesContainer extends React.Component {
  static propTypes = {
    advisers: PropTypes.array.isRequired,
    adviserStatusCodes: PropTypes.array.isRequired,
    fetchingAdvisers: PropTypes.bool.isRequired,
    fetchedAdviserStatusCodes: PropTypes.bool.isRequired,
    submitAdviser: PropTypes.bool.isRequired,
    submittingAdviser: PropTypes.bool.isRequired,
    submittedAdviser: PropTypes.bool.isRequired,
    adviserIndex: PropTypes.number.isRequired,
    searchTerm: PropTypes.string,

    fetchAdvisers: PropTypes.func.isRequired,
    fetchAdvisersByName: PropTypes.func.isRequired,
    fetchAdviserStatusCodes: PropTypes.func.isRequired,
    setAdviser: PropTypes.func.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    submitAdviserStatusCode: PropTypes.func.isRequired
  }

  componentDidMount () {
    this.props.fetchAdviserStatusCodes()
    this.props.fetchAdvisers()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.submitAdviser && this.props.submitAdviser) {
      const { advisers, adviserIndex } = this.props;
      this.props.submitAdviserStatusCode(advisers[adviserIndex]);
    }
  }

  addIfa () {
    history.push('add-ifa')
  }

  render () {
    if (this.props.fetchingAdvisers || !this.props.fetchedAdviserStatusCodes) {
      return <Spinner />
    }

    return <AdviserProfiles
      advisers={this.props.advisers}
      adviserStatusCodes={this.props.adviserStatusCodes}
      submitAdviser={this.props.submitAdviser}
      submittingAdviser={this.props.submittingAdviser}
      submittedAdviser={this.props.submittedAdviser}
      adviserIndex={this.props.adviserIndex}
      searchTerm={this.props.searchTerm}
      setAdviser={this.props.setAdviser}
      setSearchTerm={this.props.setSearchTerm}
      fetchBySearchTerm={this.props.fetchAdvisersByName}
      fetchAllAdvisers={this.props.fetchAdvisers}
      addIfa={this.addIfa}
    />
  }
}

const mapStateToProps = ({ advisersWhitelist }) => {
  return {
    advisers: advisersWhitelist.advisers,
    adviserStatusCodes: advisersWhitelist.adviserStatusCodes,
    fetchingAdvisers: advisersWhitelist.fetchingAdvisers,
    fetchedAdviserStatusCodes: advisersWhitelist.fetchedAdviserStatusCodes,
    submitAdviser: advisersWhitelist.submitAdviser,
    submittingAdviser: advisersWhitelist.submittingAdviser,
    submittedAdviser: advisersWhitelist.submittedAdviser,
    adviserIndex: advisersWhitelist.adviserIndex,
    searchTerm: advisersWhitelist.searchTerm
  }
}

const mapDispatchToProps = (dispatch) => {
  const { load, set, submit } = actions

  return bindActionCreators({
    fetchAdvisers: load.fetchAdvisers,
    fetchAdvisersByName: load.fetchAdviserProfiles,
    fetchAdviserStatusCodes: load.fetchAdviserStatusCodes,
    setAdviser: set.adviserStatusCode,
    setSearchTerm: set.searchTerm,
    submitAdviserStatusCode: submit.submitAdviserStatusCode
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserProfilesContainer)
